
import React from 'react';
import { TableHead } from '@/components/ui/table';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SortableTableHeaderProps {
  label: string;
  sortKey: string;
  currentSort: string | null;
  sortDirection: 'asc' | 'desc';
  onSort: (key: string) => void;
  className?: string;
}

const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  label,
  sortKey,
  currentSort,
  sortDirection,
  onSort,
  className
}) => {
  const isActive = currentSort === sortKey;
  
  const getSortIcon = () => {
    if (!isActive) return <ArrowUpDown className="h-4 w-4" />;
    return sortDirection === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />;
  };

  return (
    <TableHead className={className}>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onSort(sortKey)}
        className="h-auto p-0 font-medium hover:bg-transparent"
      >
        {label}
        <span className="ml-2">{getSortIcon()}</span>
      </Button>
    </TableHead>
  );
};

export default SortableTableHeader;
